import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components/macro';
import BootstrapTooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Placement } from 'react-bootstrap/esm/Overlay';

type Props = {
  value: ReactNode;
  placement?: Placement;
  className?: string;
  children: ReactElement;
};

export const Tooltip = (props: Props) => {
  const { children, className, placement = 'top', value } = props;

  const tooltip = <StyledTooltip id="tooltip">{value}</StyledTooltip>;

  return (
    <div className={className}>
      <OverlayTrigger placement={placement} overlay={tooltip}>
        {children}
      </OverlayTrigger>
    </div>
  );
};

const StyledTooltip = styled(BootstrapTooltip)`
  font-size: 1rem;
  display: block;
`;
